<template>
  <owal-modal
    :show="show"
    class="owal camera picker modal"
  >
    <div
      slot="content"
      class="owal camera picker panel"
      >
      <div
        class="owal panel header bar"
      >
        <div
          class="owal panel header title bar"
        >
          <span
            class="owal panel header left button"
            style="cursor: pointer;"
            @click="closeClicked"
          >
            Cancel
          </span>
          <h3
            class="title"
          >
            Faces
          </h3>
          <span
            class="owal panel header right button"
            style="cursor: pointer;"
            @click="saveSelection"
          >
            Select
          </span>
        </div>
      </div>
      <div
        class="owal-search-bar__wrapper"
      >
      <!--
        <input
          v-model="search"
          class="owal-search-bar__input"
          placeholder="Search Faces"
          icon="search"
        >
        -->
      </div>
      <div
        class="owal-picker__option-list"
      >
        <select
          v-model="selectedIds"
          class="owal-picker__option-list-select"
          multiple
        >
          <option
            value=""
            class="owal-picker__option-list-option"
          >
            {{ alternativeDataSource ? 'Me' : 'Any Person' }}
          </option>
          <option
            v-for="face in sortedFaces"
            :key="face.frontend_face_uuid"
            class="owal-picker__option-list-option"
            :value="face.frontend_face_uuid"
          >
            {{ face.person_name }}
          </option>
        </select>
      </div>
    </div>
  </owal-modal>
</template>

<script>
import OwalModal from '@/libraries/owal-ui/modals/OwalModal'
import { mapGetters } from 'vuex'
import { toggle } from '@/libraries/util/array'
import { filterFaces } from '@/libraries/util/filterFaces'
import { Operation, Service } from '@/libraries/permissions'

export default {
  name: 'OwalPersonPicker',
  components: {
    OwalModal,
  },
  props: {
    show: {
      type: Boolean,
      default: false,
    },
    changeHandler: {
      type: Function,
      default: undefined,
    },
    initialSelection: {
      type: Array,
      default: function () {
        return []
      },
    },
    /**
     * An array of of objects that are "face-ish."
     * This means that they have enough information for the picker
     * to select, sort, and filter them.
     * Here's what the bare minimum face-ish object looks like:

     {
       frontend_face_uuid: 'uuid...',
       last_name: 'Doe',
       person_name: 'John Doe',
       role: '' // See /owal/owal/js/cameras/src/libraries/user-management/addFace.js line 28 for valid roles.
     }

     * Any similar data set can work, as long as you map the input to objects that resemble these.
     *
     */
    alternativeDataSource: {
      type: Array,
    },
  },
  data () {
    return {
      search: '',
      selectedIds: [],
    }
  },
  mounted () {
    this.selectedIds = this.initialSelection
  },
  computed: {
    ...mapGetters(['frontendFaces', 'isAuthenticated', 'refreshing']),
    canSeeStaff () {
      console.log('canSeeStaff performing entitlements check')
      return this.canPerformOperationForService(Service.FACES, Operation.FIND_ALL)
    },
    displayFaces () {
      return this.alternativeDataSource || this.frontendFaces
    },
    filteredFaces () {
      const search = this.search
      const filtered = filterFaces(search, this.displayFaces, this.canSeeStaff, false)
      return filtered
    },
    sortedFaces () {
      const filtered = this.filteredFaces || []
      const faces = filtered.sort(this.compareFaces)
      return faces
    },
  },
  methods: {
    ...mapGetters({
      canPerformOperationForService: 'entitlements/canPerformOperationForService',
    }),
    toggle,
    filterFaces,
    closeClicked: function () {
      this.$emit('close-clicked') /* deprecated - use close, but keep this for legacy code. */
      this.$emit('close')
    },
    saveSelection: function () {
      if (this.changeHandler) {
        this.changeHandler(this.selectedIds)
      }
      this.closeClicked()
    },
    optionIsSelected (optionValue) {
      const selected = this.selectedIds.includes(optionValue)

      return selected ? 'selected' : 'false'
    },
    compareFaces (faceA, faceB) {
      const nameA = faceA.last_names
      const nameB = faceB.last_name

      if (!nameA && !nameB) {
        return 0
      }

      if (!nameB || !nameB.last_name) {
        return -1
      }

      if (!nameA || !nameA.last_name) {
        return 1
      }

      return nameA > nameB
    },
  },
}
</script>

<style scoped>
.owal.camera.picker.modal {
  display: flex;
  height: 100%;
  overflow: auto;
  padding: 5rem;
}
.owal.camera.picker.panel {
  display: flex;
  flex-direction: column;
  overflow-x: hidden;
  width: 320px;
  background-color: #F3F4F5;
  box-shadow: 0 0 5px #555;
  border-radius: 5px;
  max-height: 100%;
}

.owal.panel.header.bar {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  align-content: center;
  width: 100%;
  height: 3.1875rem;
  flex-shrink: 0;
  margin: 0 !important;
  padding: 0 !important;
}

.owal.panel.header.title.bar {
  padding: 0 !important;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  align-content: center;
  background: #475669;
  color: #EFF2F7;
}

.owal.panel.header.title.bar h3 {
  flex-shrink: 2;
  margin: 0 !important;
  padding: 0 !important;
}

.owal.panel.header.left.button {
  margin: 0 !important;
  margin-left: 1.1rem !important;
  padding: 0 !important;
}

.owal.panel.header.right.button {
  margin: 0 !important;
  margin-right: 1.1rem !important;
  padding: 0 !important;
  font-weight: bold;
}

.owal-search-bar__wrapper {
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
  width: 100%;
  height: 44px;
  padding: 0 0.75rem !important;
  margin: 0;
}

.owal-search-bar__input {
  border: 2px solid #E0E0E0;
  border-radius: 5px;
  width: 100%;
  height: 30px;
  padding: 5px;
}

.owal-search-bar__input::-moz-placeholder,
.owal-search-bar__input::-webkit-input-placeholder {
   color: #E0E0E0;
}

.owal-picker__option-list {
  box-sizing: border-box;
}

.owal-picker__option-list-select {
  background: #F0F0F0;
  border: 2px solid #E0E0E0;
  border-bottom-left-radius: 5px;
  border-bottom-right-radius: 5px;

  font-family: 'Lato-Regular', sans-serif;
  font-size: 1.28571rem;
  color: #324057;
  letter-spacing: 0;
  padding: 0.87571rem 0.64285rem;
  box-sizing: border-box;
  margin: 0;
  max-height: 100%;
  width: 100%;
  flex-grow: 0;
  text-align: center;
}

@media only screen and (min-height: 641px) {
  .owal-picker__option-list-select {
    height: 440px;
  }
}

@media only screen and (max-width: 640px) {
    .owal-picker__option-list-select {
    height: 320px;
  }
}

.owal-picker__option-list-option {
  height: 3.1428571429rem;
  border-bottom: 1px solid #E0E0E0;
  display: flex;
  justify-content: center;
  align-items: center;
}

</style>
